module.exports = __webpack_public_path__ + "73749bc8d04f0aca3cf94d4ab189b436.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_3_2023_chart.png
// module id = 1670
// module chunks = 0